
import { Eye, Target, Handshake, CheckCircle } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import React from "react";

const visionData = {
    icon: Eye,
    title: "Our Vision",
    text: "To revolutionize global travel by becoming the most trusted and accessible digital visa solutions provider in the industry"
};

const missionData = {
    icon: Target,
    title: "Our Mission",
    text: "Our mission is to simplify and accelerate visa processing through innovative technology, exceptional customer service and transparent operations"
};

const valuesData = {
    icon: Handshake,
    title: "Our Values",
    items: [
        "Customer-Centricity",
        "Integrity & Transparency",
        "Innovation & Efficiency",
        "Accuracy & Compliance",
        "Global Accessibility",
        "Professionalism & Accountability",
        "Confidentiality & Security"
    ]
};

export function MissionVisionValues() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Vision Card */}
      <Card className="relative bg-[#e71875]/5 border-[#e71875]/20 p-8 rounded-2xl overflow-hidden flex flex-col justify-center items-center text-center gsap-wwa-mission-card">
        <visionData.icon className="absolute -bottom-10 -right-10 text-[#e71875]/10 h-48 w-48" />
        <CardContent className="relative z-10 p-0">
          <h3 className="text-sm font-semibold text-[#e71875] uppercase tracking-wider">Our</h3>
          <h2 className="text-5xl font-bold text-[#e71875]/90">VISION</h2>
          <p className="mt-4 text-[#e71875]/80 text-lg max-w-sm mx-auto">
            {visionData.text}
          </p>
        </CardContent>
      </Card>
      
      {/* Mission Card */}
      <Card className="relative bg-[#e71875]/5 border-[#e71875]/20 p-8 rounded-2xl overflow-hidden flex flex-col justify-center items-center text-center gsap-wwa-mission-card">
        <missionData.icon className="absolute -top-10 -left-10 text-[#e71875]/10 h-48 w-48" />
        <CardContent className="relative z-10 p-0">
          <h3 className="text-sm font-semibold text-[#e71875] uppercase tracking-wider">Our</h3>
          <h2 className="text-5xl font-bold text-[#e71875]/90">MISSION</h2>
          <p className="mt-4 text-[#e71875]/80 text-lg max-w-sm mx-auto">
            {missionData.text}
          </p>
        </CardContent>
      </Card>
      
      {/* Values Card */}
      <div className="lg:col-span-2">
        <Card className="relative bg-[#e71875]/5 border-[#e71875]/20 p-8 rounded-2xl overflow-hidden gsap-wwa-mission-card">
            <valuesData.icon className="absolute -bottom-8 -right-8 text-[#e71875]/10 h-56 w-56" />
            <CardContent className="relative z-10 p-0 grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="md:col-span-1 text-center md:text-left">
                    <h3 className="text-sm font-semibold text-[#e71875] uppercase tracking-wider">Our</h3>
                    <h2 className="text-5xl font-bold text-[#e71875]/90">VALUES</h2>
                </div>
                <div className="md:col-span-2">
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                        {valuesData.items.map((value, index) => (
                            <li key={index} className="flex items-center text-lg text-[#e71875]/95 font-medium">
                                <CheckCircle className="h-5 w-5 mr-3 text-[#e71875]/70" />
                                {value}
                            </li>
                        ))}
                    </ul>
                </div>
            </CardContent>
        </Card>
      </div>
    </div>
  );
}
